<template>
  <div v-if="loaded">
    <div class="card card-custom gutter-b">
      <div class="card-body">
        <!--begin::Details-->
        <div className="row">
          <div className="col">
            <div class="my-5">
              <div class="form-group row">
                <label class="col-3">عنوان شرکت</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    disabled
                    type="text"
                    :value="adminCompany.title"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">نام انگلیسی شرکت</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    disabled
                    type="text"
                    :value="adminCompany.name"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">تعداد کاربران</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    :value="adminCompany.users_count"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">امکان قرض کردن</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    :value="attributes['IS_ELIGIBLE_TO_BORROW'] ? 'بله' : 'خیر'"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">کیف پول اشتراکی</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    :value="
                      attributes['IS_WALLET_SHARED'] === '1' ? 'بله' : 'خیر'
                    "
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">PRICE_LIVE_BASE</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    :value="attributes['PRICE_LIVE_BASE'] ?? 'فیمت پیشفرض'"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-3">PRICE_LIVE_DESTINATION</label>
                <div class="col-9">
                  <input
                    class="form-control"
                    type="text"
                    disabled
                    :value="
                      attributes['PRICE_LIVE_DESTINATION'] ?? 'فیمت پیشفرض'
                    "
                  />
                </div>
              </div>
            </div>
            <div class="separator separator-dashed my-10"></div>
          </div>
          <div class="my-5">
            <h3 class="text-dark font-weight-bold mb-10">مشخصات صاحب کمپانی</h3>
            <div class="form-group row">
              <label class="col-3">کد</label>
              <div class="col-9">
                <input
                  class="form-control"
                  disabled
                  type="text"
                  :value="adminCompany.owner_id"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-3">نام </label>
              <div class="col-9">
                <input
                  class="form-control"
                  disabled
                  type="text"
                  :value="gFullName(adminCompany.owner)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label class="col-3">تلفن</label>
              <div class="col-9">
                <input
                  class="form-control"
                  type="text"
                  disabled
                  :value="prettyPhone(adminCompany.owner.cellphone)"
                />
              </div>
            </div>
          </div>
          <!--end::Details-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_COMPANY } from "@/core/services/store/admin/users.module";
import { mapGetters } from "vuex";

export default {
  name: "adminCompany",
  data() {
    return {
      loaded: false
    };
  },
  components: {},
  mounted() {
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [],
      links: [
        {
          name: "بازگشت",
          to: { name: "admin-companies-index" }
        }
      ]
    });

    this.getCompany();
  },
  computed: {
    ...mapGetters(["adminCompany"]),
    attributes() {
      let data = [];
      this.adminCompany.attributes.forEach(attribute => {
        data[attribute.name] = attribute.value;
      });

      return data;
    }
  },
  methods: {
    getCompany() {
      let userId = this.$route.params.id;
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_COMPANY, userId)
        .then(() => {
          this.loaded = true;
          this.$store.dispatch(SET_BREADCRUMB, [
            {
              title: "مدیریت",
              route: { name: "admin-dashboard" }
            },
            { title: "شرکت ها", route: { name: "admin-companies-index" } },
            { title: this.adminCompany.title }
          ]);
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
